module.exports = __webpack_public_path__ + "img/DocumentRouting.5617022c.svg";